module.exports = {
  failed: 'Validation failed.',
  failedBecauseX: 'Validation failed. Underlying reason: {0}',
  objectXIsMissingFieldsY: 'The {0} is missing the following fields: {1}',
  objectXHasForbiddenFieldsY: 'The {0} has the following forbidden fields: {1}',
  objectXMustProvideOneOfFieldsY: 'A {0} requires that at least one of the following fields is specified: {1}',
  activityXProvidedUnvalidatedFieldsY: 'When performing the {0} activity, the following unvalidated fields were stripped: {1}',
  updateIdMismatchForTypeX: 'The id of the {0} must not be changed when updating',
  fieldXMustBeOneOfY: "'{0}' must be one of: {1}",
  fieldXOfTypeYMayNotBeChanged: "{1} '{0}' may not be changed.",
  boolean: { fieldXMustBeABoolean: 'The provided {0} is not a valid boolean.' },
  date: {
    fieldXIsNotAValidDate: 'The provided {0} is not a valid date.',
    fieldXCannotBeInFuture: 'The {0} cannot be in the future.',
    fieldXCannotBeInPast: 'The {0} cannot be in the past.',
    fieldXMustBeInPast: 'The {0} must be in the past.',
    fieldXMustBeInFuture: 'The {0} must be in the future.',
  },
  db: {
    successfullyAddedTypeX: 'Completed addition of new {0}',
    missingTypeXWithIdY: 'Could not find the {0} with Id \'{1}\'',
    failedToGetListOfTypeXBecauseY: 'An error occurred getting {0}.  Error: {1}.',
    failedToGetIdXTypeYBecauseZ: 'An error occurred getting {1} with Id \'{0}\'.  Error: {2}',
    failedToAddXBecauseY: 'An error occurred adding {0}.  Error: {1}.',
  },
  fieldXDoesNotReferenceAValidY: '{0} does not reference a valid {1}.',
  number: {
    fieldXMustBeAnInteger: '{0} must be an integer.',
    fieldXMustBeBetweenYAndZ: '{0} must be between {1} and {2}.',
  },
  string: {
    fieldXIsEmpty: '{0} must contain displayable text.',
    fieldXFailedSantization: '{0} contains illegal characters or text.',
    fieldXIsNotAValidEmail: 'The value provided for {0} is not a valid email address.',
    fieldXIsNotAValidUuid: 'The value provided for {0} is not a valid UUID.',
  },
};
